/**
 * NSM model detail page — /gallery/:slug. Luxury editorial layout, image-first.
 */
import React, { useEffect, useState } from "react";
import { useParams, Navigate, Link } from "react-router-dom";
import BackToTop from "../../components/elements/BackToTop";
import Header from "../../components/site/Header";
import Footer from "../../components/site/Footer";
import { getGalleryItemBySlug } from "../../config/gallery";

export default function ModelDetail() {
  const { slug } = useParams();
  const [scrollVisible, setScrollVisible] = useState(false);
  const model = getGalleryItemBySlug(slug);

  useEffect(() => {
    document.body.classList.add("route-gallery");
    return () => document.body.classList.remove("route-gallery");
  }, []);

  useEffect(() => {
    const onScroll = () => setScrollVisible(window.scrollY > 300);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!model) return <Navigate to="/gallery" replace />;

  const images = model.images || [model.image];

  return (
    <>
      <Header />
      <main className="nsm-model-detail">
        <div className="container">
          <div className="nsm-model-detail__head">
            <Link to="/gallery" className="nsm-model-detail__back">
              ← Back to Gallery
            </Link>
            <p className="nsm-model-detail__label">{model.category}</p>
            <h1 className="nsm-model-detail__title">{model.name}</h1>
          </div>

          <div className="nsm-model-detail__grid">
            {images.map((img, i) => (
              <div
                key={i}
                className={`nsm-model-detail__cell ${i === 0 ? "nsm-model-detail__cell--lead" : ""}`}
              >
                <img
                  src={img}
                  alt={`${model.name} — NSM 2026 gallery ${i + 1}`}
                />
              </div>
            ))}
          </div>
        </div>
      </main>
      <BackToTop scroll={scrollVisible} />
      <Footer />
    </>
  );
}
